<template>
  <div id="app" style="font-family: Manrope">
    <Navbar class="mb-5" />
    <Content />
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/templates/NavbarPmse.vue"
import Content from "@/components/templates/Content.vue"
import Footer from "@/components/templates/Footer.vue"
export default {
  name: "PmseLayout",
  components: {
    Navbar,
    Content,
    Footer,
  },
}
</script>
